import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash/fp';
import isPhysicianUserId from '@medflex/utils/isPhysicianUserId';
import useUserProfile from './useUserProfile';

const usePhysicianStatus = physicianUserIds => {
  const { userProfile } = useUserProfile();
  const dispatch = useDispatch();
  const { loadStatus, updateStatusVisibility } = dispatch.physicianStatus;
  const isLoadingStatus = useSelector(({ loading }) => loading.effects.physicianStatus.loadStatus);
  const status = useSelector(({ physicianStatus }) => physicianStatus);

  const toggleVisibility = ({ physicianUserId }) => {
    updateStatusVisibility({
      physicianUserId,
      remember: true,
      statusDisplayed: !status[physicianUserId]?.statusDisplayed,
    });
  };

  const physicianIds = useMemo(() => {
    const allowedPhysicianUserIds = physicianUserIds?.reduce((acc, physicianUserId) => {
      if (userProfile.id === physicianUserId) return acc;
      if (!isPhysicianUserId(physicianUserId)) return acc;

      acc.push(physicianUserId);
      return acc;
    }, []);

    return allowedPhysicianUserIds;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(physicianUserIds)]);

  useEffect(() => {
    if (physicianIds.length) {
      loadStatus({
        physicianIds: physicianIds.filter(physicianUserId => !status[physicianUserId]),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadStatus, physicianIds]);

  return {
    status: _.pick(physicianIds, status),
    isLoadingStatus,
    toggleVisibility,
  };
};

export default usePhysicianStatus;
